export default __webpack_public_path__ + "static/media/close-catalog.bea0d465.svg";